import {
  formatIs, RankedTester,
  rankWith,
} from "@jsonforms/core";
import {ResourceType} from "../../resource/resource.type";

export const micrositeSelectionRendererTester: RankedTester =
  rankWith(2, formatIs(ResourceType.iframe));
